import Swiper from 'swiper';

class SingleSlider {
  constructor() {
    this.component = document.querySelector('[data-component="single-slider"]');
    this.trigger = document.querySelector('[data-trigger="single-slider"]');
    this._init();
  }

  _init() {
    if (this.component && this.trigger) {
      let swiper = null;

      
      swiper = new Swiper(this.trigger, {
        slidesPerView: 'auto',
        spaceBetween: 30,
        preventClicks: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
  }
}

export const singleSlider = new SingleSlider();
